import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-doc-article-porus',
  templateUrl: './doc-article-porus.component.html',
  styleUrls: ['./doc-article-porus.component.css']
})
export class DocArticlePorusComponent implements OnInit {
    docArticleKeyno;

    public itemsListReadActivities: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.docArticleKeyno = this.stateService.getStateParams()['docarticle_keyno'];
    }

    private async loadReadActivities() {
        if (!!this.docArticleKeyno) {
            this.itemsListReadActivities = await this.datatask.Post(1379, { docarticle_keyno: this.docArticleKeyno });
        }
    }

    private async init() {
        this.loadReadActivities();
    }

    ngOnInit() {
        this.init();
    }
}
